import {APPLIED_JOBS_VENDOR_FAIL,APPLIED_JOBS_VENDOR_SUCCESS,APPLIED_JOBS_VENDOR_REQUEST} from "../constants/AuthConstant"

  
  const initialState = {
    loading: false,
    action: "Job Action",
    result: null,
    msg: "",
    error: "",
  };
  
  const AppliedJobsVendorReducer = (state = initialState, action) => {
    switch (action.type) {
      case APPLIED_JOBS_VENDOR_REQUEST:
        return {
          ...state,
          loading: action.payload,
        };
      case APPLIED_JOBS_VENDOR_SUCCESS:
        return {
          ...state,
          result: action.result.data,
          loading: action.payload,
          msg: action.msg,
        };
      case APPLIED_JOBS_VENDOR_FAIL:
        return {
          ...state,
          error: action.error,
          loading: action.payload,
          msg: action.msg,
        };
  
      default:
        return state;
    }
  };
  
  export default AppliedJobsVendorReducer;
  